export interface ScrollOverflowEdges {
    end: boolean;
    start: boolean;
}

interface ScrollMeasurements {
    clientHeight: number;
    scrollHeight: number;
    scrollTop: number;
}

const OVERFLOW_THRESHOLD = 1;

export const getScrollOverflowEdges = (
    { clientHeight, scrollHeight, scrollTop }: ScrollMeasurements,
    threshold = OVERFLOW_THRESHOLD,
): ScrollOverflowEdges => {
    const maximumScrollTop = Math.max(scrollHeight - clientHeight, 0);
    const overflowing = maximumScrollTop > threshold;

    return {
        end: overflowing && scrollTop < maximumScrollTop - threshold,
        start: overflowing && scrollTop > threshold,
    };
};
